import { assertTokenValidForMutation, handleResponse } from "./service-helpers";

const NBH_SOCIAL_ACCOUNT_ENABLED_ADMIN_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/organization-settings/social-account-enabled`;
const NBH_SOCIAL_ACCOUNT_ENABLED_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/options/social-account-enabled`;
const NBH_OVERDRAFT_ALLOWED_ADMIN_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/organization-settings/overdraft-allowed`;
const NBH_OVERDRAFT_ALLOWED_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/options/overdraft-allowed`;
const NBH_SOCIAL_ACCOUNT_BALANCE_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/options/social-account-balance`;

export interface SocialAccountEnabledResponse {
    enabled: boolean;
}

export interface OverdraftAllowedResponse {
    allowed: boolean;
}

export interface SocialAccountBalanceResponse {
    balance: number;
}

export async function getSocialAccountEnabled(token: string): Promise<boolean> {
    const response = await fetch(NBH_SOCIAL_ACCOUNT_ENABLED_USER_URL, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    const data = await handleResponse<SocialAccountEnabledResponse>(response) as SocialAccountEnabledResponse;
    return data.enabled;
}

export async function updateSocialAccountEnabled(token: string, enabled: boolean): Promise<boolean> {
    assertTokenValidForMutation()
    const response = await fetch(NBH_SOCIAL_ACCOUNT_ENABLED_ADMIN_URL, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ enabled })
    });

    const data = await handleResponse<SocialAccountEnabledResponse>(response) as SocialAccountEnabledResponse;
    return data.enabled;
}

export async function getOverdraftAllowed(token: string): Promise<boolean> {
    const response = await fetch(NBH_OVERDRAFT_ALLOWED_USER_URL, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    const data = await handleResponse<OverdraftAllowedResponse>(response) as OverdraftAllowedResponse;
    return data.allowed;
}

export async function getSocialAccountBalance(token: string): Promise<number> {
    const response = await fetch(NBH_SOCIAL_ACCOUNT_BALANCE_USER_URL, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    const data = await handleResponse<SocialAccountBalanceResponse>(response) as SocialAccountBalanceResponse;
    return data.balance;
}

export async function updateOverdraftAllowed(token: string, allowed: boolean): Promise<boolean> {
    assertTokenValidForMutation()
    const response = await fetch(NBH_OVERDRAFT_ALLOWED_ADMIN_URL, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ allowed })
    });

    const data = await handleResponse<OverdraftAllowedResponse>(response) as OverdraftAllowedResponse;
    return data.allowed;
}
